(function () {
  var SAMPLE_RATE = 24000;
  var CHUNK_MS = 100;
  var WORKLET_SOURCE = [
    "class ArmyCareCapture extends AudioWorkletProcessor {",
    "  constructor() {",
    "    super();",
    "    this._q = [];",
    "    this._needed = Math.round(sampleRate * 0.1);",
    "  }",
    "  process(inputs) {",
    "    var ch = inputs[0] && inputs[0][0];",
    "    if (!ch) return true;",
    "    for (var i = 0; i < ch.length; i++) this._q.push(ch[i]);",
    "    while (this._q.length >= this._needed) {",
    "      var slice = this._q.splice(0, this._needed);",
    "      var pcm = new Int16Array(slice.length);",
    "      var sum = 0;",
    "      for (var j = 0; j < slice.length; j++) {",
    "        var s = Math.max(-1, Math.min(1, slice[j]));",
    "        pcm[j] = s < 0 ? s * 0x8000 : s * 0x7fff;",
    "        sum += s * s;",
    "      }",
    "      this.port.postMessage({ pcm: pcm.buffer, rms: Math.sqrt(sum / slice.length) }, [pcm.buffer]);",
    "    }",
    "    return true;",
    "  }",
    "}",
    "registerProcessor('army-care-capture', ArmyCareCapture);"
  ].join("\n");

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function escapeHtml(text) {
    return String(text || "").replace(/[&<>"']/g, function (ch) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[ch];
    });
  }

  function linkify(text) {
    return escapeHtml(text).replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>');
  }

  function isStoreUrl(url) {
    try {
      var parsed = new URL(url);
      var host = parsed.hostname;
      if (host !== "www.army-clothing.net" && host !== "army-clothing.net") return false;
      if (parsed.pathname.indexOf("/products/") === 0) return true;
      if (parsed.pathname.indexOf("/collections/") === 0) return true;
      if (parsed.pathname.indexOf("/pages/") === 0) return true;
      return parsed.pathname === "/" && parsed.hash === "#vip-bespoke-embroidery";
    } catch (err) {
      return false;
    }
  }

  function isShopifyImage(url) {
    try {
      var host = new URL(url).hostname;
      return host === "cdn.shopify.com" || host.slice(-12) === ".shopify.com";
    } catch (err) {
      return false;
    }
  }

  function int16ToBase64(int16) {
    var bytes = new Uint8Array(int16.buffer, int16.byteOffset, int16.byteLength);
    var binary = "";
    for (var i = 0; i < bytes.length; i += 0x8000) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
    }
    return btoa(binary);
  }

  function base64ToInt16(b64) {
    var binary = atob(b64);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return new Int16Array(bytes.buffer);
  }

  function resampleTo24k(float32, inputRate) {
    if (inputRate === SAMPLE_RATE) return float32;
    var ratio = inputRate / SAMPLE_RATE;
    var outLen = Math.max(1, Math.floor(float32.length / ratio));
    var out = new Float32Array(outLen);
    for (var i = 0; i < outLen; i++) {
      var x = i * ratio;
      var i0 = Math.floor(x);
      var i1 = Math.min(i0 + 1, float32.length - 1);
      var f = x - i0;
      out[i] = float32[i0] * (1 - f) + float32[i1] * f;
    }
    return out;
  }

  function pcm16To24k(int16, inputRate) {
    if (inputRate === SAMPLE_RATE) return int16;
    var float32 = new Float32Array(int16.length);
    for (var i = 0; i < int16.length; i++) float32[i] = int16[i] / 32768;
    return floatToPcm16(resampleTo24k(float32, inputRate));
  }

  function floatToPcm16(float32) {
    var out = new Int16Array(float32.length);
    for (var i = 0; i < float32.length; i++) {
      var s = Math.max(-1, Math.min(1, float32[i]));
      out[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
    return out;
  }

  function mountMarkup(root) {
    if (root.querySelector("[data-care-open]")) return;
    var email = root.dataset.contactEmail || "armyclothingstore@gmail.com";
    root.innerHTML = [
      '<button type="button" class="ac-care__launcher" data-care-open aria-expanded="false" aria-controls="ArmyCarePanel">',
      '  <span class="ac-care__launcher-icon" aria-hidden="true">',
      '    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>',
      "  </span>",
      '  <span class="ac-care__launcher-copy"><strong>Customer Care</strong><em>Text or voice</em></span>',
      "</button>",
      '<section id="ArmyCarePanel" class="ac-care__panel" data-care-panel hidden role="dialog" aria-modal="true" aria-labelledby="ArmyCareTitle">',
      '  <header class="ac-care__header">',
      '    <div class="ac-care__brand"><span class="ac-care__pulse" data-care-pulse aria-hidden="true"></span><div><h2 id="ArmyCareTitle">Customer Care</h2><p data-care-status>Text or voice chat for Army Clothing</p></div></div>',
      '    <button type="button" class="ac-care__icon-btn" data-care-close aria-label="Close customer care"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"></path></svg></button>',
      "  </header>",
      '  <div class="ac-care__modes" role="tablist" aria-label="Chat mode">',
      '    <button type="button" class="ac-care__mode is-active" data-care-mode="text" role="tab" aria-selected="true">Text chat</button>',
      '    <button type="button" class="ac-care__mode" data-care-mode="talk" role="tab" aria-selected="false">Talk</button>',
      "  </div>",
      '  <div class="ac-care__messages" data-care-messages role="log" aria-live="polite"></div>',
      '  <div class="ac-care__talk" data-care-talk hidden>',
      '    <button type="button" class="ac-care__talk-btn" data-care-talk-toggle><span class="ac-care__talk-mic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="2" width="6" height="12" rx="3"></rect><path d="M5 11a7 7 0 0 0 14 0"></path><path d="M12 18v4"></path><path d="M8 22h8"></path></svg></span><span data-care-talk-label>Start voice chat</span></button>',
      '    <div class="ac-care__meter" data-care-meter aria-hidden="true"><span></span></div>',
      '    <p class="ac-care__talk-hint">Speak naturally. We reply by voice, and the transcript appears above.</p>',
      "  </div>",
      '  <form class="ac-care__composer" data-care-form>',
      '    <label class="visually-hidden" for="ArmyCareInput">Message Army Clothing</label>',
      '    <textarea id="ArmyCareInput" data-care-input rows="1" placeholder="Ask about a regiment, order, or delivery…" maxlength="2000" inputmode="text" enterkeyhint="send" autocomplete="off" autocapitalize="sentences"></textarea>',
      '    <button type="submit" class="ac-care__send" data-care-send aria-label="Send message"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 12 14-7-7 14-2-5-5-2z"></path></svg></button>',
      "  </form>",
      '  <p class="ac-care__legal">Powered by Grok. Human team: <a href="mailto:' + email + '">' + email + "</a></p>",
      "</section>"
    ].join("");
  }

  ready(function () {
    var root = document.querySelector("[data-army-care]");
    if (!root || root.dataset.ready) return;
    mountMarkup(root);
    root.dataset.ready = "true";

    var apiBase = (root.dataset.apiBase || "").replace(/\/$/, "");
    var greeting = root.dataset.greeting || "Welcome to Army Clothing Customer Care. How can I help you today?";
    var email = root.dataset.contactEmail || "armyclothingstore@gmail.com";
    var openBtn = root.querySelector("[data-care-open]");
    var closeBtn = root.querySelector("[data-care-close]");
    var panel = root.querySelector("[data-care-panel]");
    var messagesEl = root.querySelector("[data-care-messages]");
    var form = root.querySelector("[data-care-form]");
    var input = root.querySelector("[data-care-input]");
    var sendBtn = root.querySelector("[data-care-send]");
    var statusEl = root.querySelector("[data-care-status]");
    var talkWrap = root.querySelector("[data-care-talk]");
    var talkBtn = root.querySelector("[data-care-talk-toggle]");
    var talkLabel = root.querySelector("[data-care-talk-label]");
    var meterFill = root.querySelector("[data-care-meter] span");
    var modeButtons = Array.prototype.slice.call(root.querySelectorAll("[data-care-mode]"));

    var history = [];
    var mode = "text";
    var isOpen = false;
    var sending = false;
    var voice = {
      ws: null,
      stream: null,
      ctx: null,
      stopCapture: null,
      nextPlay: 0,
      playingUntil: 0,
      sources: [],
      userBubble: null,
      assistantBubble: null,
      connecting: false,
      inFlightCalls: 0
    };

    function setStatus(text) {
      if (statusEl) statusEl.textContent = text;
    }

    function pageContext() {
      return {
        title: root.dataset.pageTitle || document.title,
        url: window.location.href,
        path: root.dataset.pageUrl || window.location.pathname
      };
    }

    var followScroll = true;
    var ignoreScroll = false;
    var scrollAnchor = null;

    function bubbleOffset(el) {
      return el.getBoundingClientRect().top - messagesEl.getBoundingClientRect().top + messagesEl.scrollTop;
    }

    function scrollToLatest() {
      if (!followScroll || !messagesEl) return;
      var el = scrollAnchor || messagesEl.lastElementChild;
      if (!el) return;
      ignoreScroll = true;
      var view = messagesEl.clientHeight;
      var top = bubbleOffset(el);
      if (el.offsetHeight + 16 >= view) {
        messagesEl.scrollTop = Math.max(0, top - 8);
      } else {
        messagesEl.scrollTop = Math.max(0, messagesEl.scrollHeight - view);
      }
      requestAnimationFrame(function () { ignoreScroll = false; });
    }

    function beginTurn(el) {
      scrollAnchor = el || null;
      followScroll = true;
      scrollToLatest();
    }

    if (messagesEl) {
      messagesEl.addEventListener("scroll", function () {
        if (ignoreScroll) return;
        var el = scrollAnchor || messagesEl.lastElementChild;
        var gap = messagesEl.scrollHeight - messagesEl.scrollTop - messagesEl.clientHeight;
        var nearStart = el ? Math.abs(messagesEl.scrollTop - Math.max(0, bubbleOffset(el) - 8)) < 72 : false;
        followScroll = gap < 72 || nearStart;
      }, { passive: true });
    }

    function addBubble(role, text) {
      var el = document.createElement("div");
      el.className = "ac-care__bubble ac-care__bubble--" + role;
      if (role === "assistant") {
        var textEl = document.createElement("div");
        textEl.className = "ac-care__bubble-text";
        textEl.innerHTML = linkify(text);
        var cardsEl = document.createElement("div");
        cardsEl.className = "ac-care__cards";
        cardsEl.hidden = true;
        el.appendChild(textEl);
        el.appendChild(cardsEl);
      } else if (role === "system") el.innerHTML = linkify(text);
      else el.textContent = text;
      messagesEl.appendChild(el);
      scrollToLatest();
      return el;
    }

    function setBubbleText(el, text, html) {
      if (!el) return;
      el.classList.remove("is-typing");
      var textEl = el.querySelector(".ac-care__bubble-text");
      if (textEl) {
        if (html) textEl.innerHTML = linkify(text);
        else textEl.textContent = text;
      } else if (html) el.innerHTML = linkify(text);
      else el.textContent = text;
      scrollToLatest();
    }

    function showTyping(el) {
      if (!el) return;
      var textEl = el.querySelector(".ac-care__bubble-text");
      el.classList.add("is-typing");
      el.classList.remove("is-streaming");
      if (textEl) {
        textEl.innerHTML = '<span class="ac-care__ticks" aria-label="Typing"><i></i><i></i><i></i></span>';
      }
      scrollToLatest();
    }

    function renderProductCards(el, payload) {
      if (!el) return;
      var cardsEl = el.querySelector(".ac-care__cards");
      if (!cardsEl) return;
      var products = Array.isArray(payload && payload.products) ? payload.products : [];
      var collections = Array.isArray(payload && payload.collections) ? payload.collections : [];
      var html = "";
      collections.forEach(function (item) {
        if (!item || !isStoreUrl(item.url)) return;
        var label = (item.url || "").indexOf("#vip-bespoke-embroidery") >= 0
          ? "Open VIP bespoke embroidery"
          : "Browse " + (item.title || "collection");
        html += '<a class="ac-care__collection" href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener">' + escapeHtml(label) + "</a>";
      });
      products.slice(0, 3).forEach(function (item) {
        if (!item || !isStoreUrl(item.url)) return;
        var image = item.image && isShopifyImage(item.image)
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="72" height="90" loading="lazy">'
          : '<span class="ac-care__card-photo" aria-hidden="true"></span>';
        var meta = [item.type, item.price].filter(Boolean).join(" · ");
        html += '<a class="ac-care__card" href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener">' +
          image +
          '<span class="ac-care__card-body"><strong>' + escapeHtml(item.title || "View product") + "</strong>" +
          (meta ? '<em>' + escapeHtml(meta) + "</em>" : "") +
          "<span>View product</span></span></a>";
      });
      if (!html) return;
      cardsEl.innerHTML = html;
      cardsEl.hidden = false;
      el.classList.add("has-cards");
      scrollToLatest();
    }

    function setMode(next) {
      mode = next;
      root.classList.toggle("is-talk-mode", next === "talk");
      modeButtons.forEach(function (btn) {
        var active = btn.getAttribute("data-care-mode") === next;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", String(active));
      });
      if (talkWrap) talkWrap.hidden = next !== "talk";
      if (form) form.hidden = next === "talk";
      setStatus(next === "talk" ? "Voice chat — tap Start, then speak" : "Customer Care");
    }

    function isCoarsePointer() {
      return window.matchMedia("(pointer: coarse)").matches || window.matchMedia("(max-width: 767px)").matches;
    }

    function setPageInert(on) {
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el === root || (el.contains && el.contains(root))) return;
        if (on) el.setAttribute("inert", "");
        else el.removeAttribute("inert");
      });
    }

    var lastVV = "";
    var viewportFrame = 0;
    var lockedScrollY = 0;
    var scrollLocked = false;
    var touchStartY = 0;

    function canScrollInsideChat(target) {
      var node = target;
      while (node && node !== document.body && node !== document.documentElement) {
        if (node === messagesEl || node === input) return true;
        node = node.parentNode;
      }
      return false;
    }

    function onLockedTouchStart(event) {
      if (!scrollLocked || !event.touches || !event.touches[0]) return;
      touchStartY = event.touches[0].clientY;
    }

    function onLockedTouchMove(event) {
      if (!scrollLocked) return;
      if (input && (event.target === input || input.contains(event.target))) return;
      if (!messagesEl || !messagesEl.contains(event.target)) {
        event.preventDefault();
        return;
      }
      var y = event.touches && event.touches[0] ? event.touches[0].clientY : touchStartY;
      var atTop = messagesEl.scrollTop <= 0;
      var atBottom = messagesEl.scrollTop + messagesEl.clientHeight >= messagesEl.scrollHeight - 1;
      var noScroll = messagesEl.scrollHeight <= messagesEl.clientHeight;
      if (noScroll || (atTop && y > touchStartY) || (atBottom && y < touchStartY)) {
        event.preventDefault();
      }
    }

    function onLockedWheel(event) {
      if (!scrollLocked) return;
      if (canScrollInsideChat(event.target)) return;
      event.preventDefault();
    }

    function lockPageScroll(on) {
      var html = document.documentElement;
      var body = document.body;
      if (on) {
        if (scrollLocked) return;
        scrollLocked = true;
        lockedScrollY = window.scrollY || html.scrollTop || 0;
        html.classList.add("army-care-open");
        body.style.position = "fixed";
        body.style.top = "-" + lockedScrollY + "px";
        body.style.left = "0";
        body.style.right = "0";
        body.style.width = "100%";
        body.style.overflow = "hidden";
        document.addEventListener("touchstart", onLockedTouchStart, { passive: true, capture: true });
        document.addEventListener("touchmove", onLockedTouchMove, { passive: false, capture: true });
        document.addEventListener("wheel", onLockedWheel, { passive: false, capture: true });
      } else {
        if (!scrollLocked) return;
        scrollLocked = false;
        html.classList.remove("army-care-open");
        body.style.position = "";
        body.style.top = "";
        body.style.left = "";
        body.style.right = "";
        body.style.width = "";
        body.style.overflow = "";
        document.removeEventListener("touchstart", onLockedTouchStart, { capture: true });
        document.removeEventListener("touchmove", onLockedTouchMove, { capture: true });
        document.removeEventListener("wheel", onLockedWheel, { capture: true });
        window.scrollTo(0, lockedScrollY);
      }
    }

    function clearCareViewport() {
      root.style.top = "";
      root.style.left = "";
      root.style.width = "";
      root.style.height = "";
      root.style.right = "";
      root.style.bottom = "";
      lastVV = "";
    }

    function syncCareViewport() {
      if (viewportFrame) return;
      viewportFrame = requestAnimationFrame(function () {
        viewportFrame = 0;
        if (!isOpen || !window.visualViewport || !window.matchMedia("(max-width: 767px)").matches) {
          clearCareViewport();
          return;
        }
        var vv = window.visualViewport;
        var key = [Math.round(vv.offsetTop), Math.round(vv.offsetLeft), Math.round(vv.width), Math.round(vv.height)].join(",");
        if (key === lastVV) return;
        lastVV = key;
        root.style.top = Math.round(vv.offsetTop) + "px";
        root.style.left = Math.round(vv.offsetLeft) + "px";
        root.style.width = Math.round(vv.width) + "px";
        root.style.height = Math.round(vv.height) + "px";
        root.style.right = "auto";
        root.style.bottom = "auto";
        requestAnimationFrame(scrollToLatest);
      });
    }

    function bindViewport(on) {
      var vv = window.visualViewport;
      if (on) {
        if (vv) {
          vv.addEventListener("resize", syncCareViewport);
          vv.addEventListener("scroll", syncCareViewport);
        }
        window.addEventListener("orientationchange", syncCareViewport);
        syncCareViewport();
      } else {
        if (vv) {
          vv.removeEventListener("resize", syncCareViewport);
          vv.removeEventListener("scroll", syncCareViewport);
        }
        window.removeEventListener("orientationchange", syncCareViewport);
        clearCareViewport();
      }
    }

    function setOpen(open) {
      isOpen = open;
      root.classList.toggle("is-open", open);
      panel.hidden = !open;
      if (openBtn) openBtn.setAttribute("aria-expanded", String(open));
      setPageInert(open);
      lockPageScroll(open);
      bindViewport(open);
      if (!open) {
        stopTalk();
        return;
      }
      requestAnimationFrame(scrollToLatest);
      if (input && !isCoarsePointer()) input.focus();
    }

    async function sendChat(text) {
      if (sending) return;
      sending = true;
      if (sendBtn) sendBtn.disabled = true;
      history.push({ role: "user", content: text });
      addBubble("user", text);
      var bubble = addBubble("assistant", "");
      beginTurn(bubble);
      showTyping(bubble);
      var assembled = "";
      try {
        var response = await fetch(apiBase + "/api/care/chat", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ messages: history, page: pageContext() })
        });
        if (!response.ok) {
          var failed = await response.json().catch(function () { return {}; });
          throw new Error(failed.error || "Customer care is unavailable right now.");
        }
        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = "";
        while (true) {
          var chunk = await reader.read();
          if (chunk.done) break;
          buffer += decoder.decode(chunk.value, { stream: true });
          var lines = buffer.split("\n");
          buffer = lines.pop() || "";
          for (var i = 0; i < lines.length; i++) {
            var line = lines[i].trim();
            if (line.indexOf("data:") !== 0) continue;
            var payload = line.slice(5).trim();
            if (!payload) continue;
            var event;
            try { event = JSON.parse(payload); } catch (err) { continue; }
            if (event.error) throw new Error(event.error);
            if (event.products || event.collections) renderProductCards(bubble, event);
            if (event.delta) {
              assembled += event.delta;
              bubble.classList.add("is-streaming");
              setBubbleText(bubble, assembled, true);
            }
            if (event.done) bubble.classList.remove("is-streaming");
          }
        }
        if (!assembled) throw new Error("No reply came back. Email " + email + ".");
        bubble.classList.remove("is-streaming");
        history.push({ role: "assistant", content: assembled });
      } catch (error) {
        var message = error && error.message ? error.message : "Please email " + email + ".";
        bubble.classList.remove("is-streaming");
        setBubbleText(bubble, message, true);
      } finally {
        sending = false;
        if (sendBtn) sendBtn.disabled = false;
      }
    }

    function stopPlayback() {
      voice.sources.forEach(function (src) {
        try { src.stop(); } catch (err) {}
      });
      voice.sources = [];
      voice.nextPlay = 0;
      voice.playingUntil = 0;
    }

    function playPcm16(int16) {
      if (!voice.ctx || !int16 || !int16.length) return;
      var float32 = new Float32Array(int16.length);
      for (var i = 0; i < int16.length; i++) float32[i] = int16[i] / 32768;
      var buffer = voice.ctx.createBuffer(1, float32.length, SAMPLE_RATE);
      buffer.getChannelData(0).set(float32);
      var src = voice.ctx.createBufferSource();
      src.buffer = buffer;
      src.connect(voice.ctx.destination);
      var now = voice.ctx.currentTime;
      if (voice.nextPlay < now) voice.nextPlay = now;
      src.start(voice.nextPlay);
      voice.nextPlay += buffer.duration;
      voice.playingUntil = Date.now() + (voice.nextPlay - now) * 1000 + 300;
      voice.sources.push(src);
      src.onended = function () {
        voice.sources = voice.sources.filter(function (item) { return item !== src; });
      };
    }

    async function startCapture(ctx, stream, onFrame) {
      var source = ctx.createMediaStreamSource(stream);
      var silent = ctx.createGain();
      silent.gain.value = 0;
      try {
        var blob = new Blob([WORKLET_SOURCE], { type: "application/javascript" });
        var url = URL.createObjectURL(blob);
        await ctx.audioWorklet.addModule(url);
        URL.revokeObjectURL(url);
        var node = new AudioWorkletNode(ctx, "army-care-capture");
        node.port.onmessage = function (event) {
          onFrame(pcm16To24k(new Int16Array(event.data.pcm), ctx.sampleRate), event.data.rms || 0);
        };
        source.connect(node);
        node.connect(silent);
        silent.connect(ctx.destination);
        return function () {
          node.disconnect();
          source.disconnect();
          silent.disconnect();
        };
      } catch (err) {
        var processor = ctx.createScriptProcessor(4096, 1, 1);
        var pending = [];
        processor.onaudioprocess = function (event) {
          var inputData = event.inputBuffer.getChannelData(0);
          var resampled = resampleTo24k(inputData, ctx.sampleRate);
          for (var i = 0; i < resampled.length; i++) pending.push(resampled[i]);
          var needed = Math.round(SAMPLE_RATE * (CHUNK_MS / 1000));
          while (pending.length >= needed) {
            var slice = pending.splice(0, needed);
            var rms = 0;
            for (var j = 0; j < slice.length; j++) rms += slice[j] * slice[j];
            onFrame(floatToPcm16(new Float32Array(slice)), Math.sqrt(rms / slice.length));
          }
        };
        source.connect(processor);
        processor.connect(silent);
        silent.connect(ctx.destination);
        return function () {
          processor.disconnect();
          source.disconnect();
          silent.disconnect();
        };
      }
    }

    function waitForPlayback(done) {
      function check() {
        if (Date.now() >= (voice.playingUntil || 0)) done();
        else setTimeout(check, 80);
      }
      check();
    }

    function sendFunctionOutput(callId, result) {
      if (!voice.ws || voice.ws.readyState !== 1) return;
      voice.ws.send(JSON.stringify({
        type: "conversation.item.create",
        item: {
          type: "function_call_output",
          call_id: callId,
          output: JSON.stringify(result || {})
        }
      }));
    }

    async function fulfillFunctionCall(event) {
      var callId = event.call_id;
      var name = event.name;
      var args = {};
      try { args = JSON.parse(event.arguments || "{}"); } catch (err) { args = {}; }
      try {
        if (name !== "search_store") {
          sendFunctionOutput(callId, { error: "Unknown function." });
          return;
        }
        setStatus("Looking up the store…");
        var query = String(args.query || "").trim();
        var response = await fetch(apiBase + "/api/care/search", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ query: query })
        });
        var data = await response.json().catch(function () { return {}; });
        if (!response.ok) throw new Error(data.error || "Catalogue search failed.");
        if (!voice.assistantBubble) voice.assistantBubble = addBubble("assistant", "");
        renderProductCards(voice.assistantBubble, data);
        sendFunctionOutput(callId, {
          collections: data.collections || [],
          products: data.products || [],
          note: data.prompt || "No catalogue matches. Send them to All Units or VIP bespoke embroidery on the homepage."
        });
      } catch (error) {
        sendFunctionOutput(callId, {
          error: "Catalogue search failed. Offer All Units or VIP bespoke embroidery on the homepage."
        });
      }
    }

    function handleVoiceEvent(event) {
      var type = event && event.type;
      if (!type) return;
      if (type === "session.created") {
        return;
      }
      if (type === "session.updated") {
        setStatus("Listening — speak when you are ready");
        return;
      }
      if (type === "input_audio_buffer.speech_started") {
        stopPlayback();
        voice.userBubble = addBubble("user", "…");
        beginTurn(voice.userBubble);
        voice.assistantBubble = null;
        setStatus("Listening");
        return;
      }
      if (type === "conversation.item.input_audio_transcription.delta" ||
          type === "conversation.item.input_audio_transcription.updated") {
        var userText = event.transcript || event.delta || event.text || "";
        if (userText) setBubbleText(voice.userBubble, userText, false);
        return;
      }
      if (type === "conversation.item.input_audio_transcription.completed") {
        var finalUser = event.transcript || (voice.userBubble && voice.userBubble.textContent) || "";
        if (finalUser && finalUser !== "…") history.push({ role: "user", content: finalUser });
        return;
      }
      if (type === "response.function_call_arguments.done") {
        voice.inFlightCalls += 1;
        fulfillFunctionCall(event).finally(function () {
          voice.inFlightCalls = Math.max(0, voice.inFlightCalls - 1);
          if (voice.inFlightCalls > 0) return;
          waitForPlayback(function () {
            if (!voice.ws || voice.ws.readyState !== 1) return;
            voice.ws.send(JSON.stringify({ type: "response.create" }));
          });
        });
        return;
      }
      if (type === "response.output_audio.delta" || type === "response.audio.delta") {
        if (event.delta) playPcm16(base64ToInt16(event.delta));
        setStatus("Speaking");
        return;
      }
      if (type === "response.output_audio_transcript.delta") {
        if (!voice.assistantBubble) voice.assistantBubble = addBubble("assistant", "");
        var current = (voice.assistantBubble.dataset.text || "") + (event.delta || "");
        voice.assistantBubble.dataset.text = current;
        setBubbleText(voice.assistantBubble, current, true);
        return;
      }
      if (type === "response.output_audio_transcript.done") {
        var spoken = voice.assistantBubble && voice.assistantBubble.dataset.text;
        if (spoken && voice.assistantBubble.dataset.saved !== "1") {
          voice.assistantBubble.dataset.saved = "1";
          history.push({ role: "assistant", content: spoken });
        }
        return;
      }
      if (type === "response.done") {
        if (!voice.inFlightCalls) setStatus("Listening — speak when you are ready");
        return;
      }
      if (type === "error") {
        addBubble("system", event.error && event.error.message ? event.error.message : "Voice hit a problem. You can keep typing.");
      }
    }

    async function connectVoice(attempt) {
      var tryCount = attempt || 1;
      var sessionRes = await fetch(apiBase + "/api/care/session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ page: pageContext() })
      });
      var session = await sessionRes.json();
      if (!sessionRes.ok || !session.token) {
        throw new Error(session.error || "Could not start voice chat.");
      }

      return new Promise(function (resolve, reject) {
        var ws = new WebSocket(session.realtimeUrl || "wss://api.x.ai/v1/realtime", [
          "xai-client-secret." + session.token
        ]);
        var settled = false;
        var sentUpdate = false;
        var updates = 0;
        var timer = setTimeout(function () {
          if (settled) return;
          ws.close();
          if (tryCount < 3) {
            connectVoice(tryCount + 1).then(resolve, reject);
          } else {
            reject(new Error("Voice chat did not start. Please type instead."));
          }
        }, 5000);

        ws.onerror = function () {
          if (settled) return;
        };
        ws.onmessage = function (message) {
          var event;
          try { event = JSON.parse(message.data); } catch (err) { return; }
          if (event.type === "session.created") {
            sentUpdate = true;
            ws.send(JSON.stringify({ type: "session.update", session: session.session }));
            return;
          }
          if (event.type === "session.updated") {
            updates += 1;
            var hasPrompt = event.session && event.session.instructions;
            if (!settled && sentUpdate && (hasPrompt || updates >= 2)) {
              settled = true;
              clearTimeout(timer);
              voice.ws = ws;
              resolve(ws);
            }
          }
          handleVoiceEvent(event);
        };
        ws.onclose = function () {
          if (voice.ws === ws) {
            root.classList.remove("is-live");
            setStatus("Voice ended. You can keep typing or start voice chat again.");
            if (talkLabel) talkLabel.textContent = "Start voice chat";
            if (form) form.hidden = mode === "talk";
          }
        };
      });
    }

    async function startTalk() {
      if (voice.connecting || voice.ws) return;
      voice.connecting = true;
      setStatus("Connecting voice chat…");
      if (talkLabel) talkLabel.textContent = "Connecting…";
      try {
        voice.stream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true, channelCount: 1 }
        });
        voice.ctx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: SAMPLE_RATE });
        if (voice.ctx.state === "suspended") await voice.ctx.resume();
        var ws = await connectVoice(1);
        voice.stopCapture = await startCapture(voice.ctx, voice.stream, function (pcm, rms) {
          if (!voice.ws || voice.ws.readyState !== 1) return;
          if (Date.now() < voice.playingUntil) return;
          if (meterFill) meterFill.style.width = Math.min(100, Math.round(rms * 280)) + "%";
          voice.ws.send(JSON.stringify({
            type: "input_audio_buffer.append",
            audio: int16ToBase64(pcm)
          }));
        });
        root.classList.add("is-live");
        if (talkLabel) talkLabel.textContent = "End talk";
        setStatus("Listening — speak when you are ready");
      } catch (error) {
        addBubble("system", error && error.message ? error.message : "Microphone or voice chat is unavailable.");
        stopTalk();
      } finally {
        voice.connecting = false;
      }
    }

    function stopTalk() {
      if (voice.ws) {
        try { voice.ws.close(); } catch (err) {}
      }
      if (voice.stopCapture) voice.stopCapture();
      stopPlayback();
      if (voice.stream) {
        voice.stream.getTracks().forEach(function (track) { track.stop(); });
      }
      if (voice.ctx) {
        voice.ctx.close().catch(function () {});
      }
      voice.ws = null;
      voice.stream = null;
      voice.ctx = null;
      voice.stopCapture = null;
      root.classList.remove("is-live");
      if (talkLabel) talkLabel.textContent = "Start voice chat";
      if (form) form.hidden = mode === "talk";
      if (meterFill) meterFill.style.width = "8%";
    }

    function ensureGreeting() {
      if (messagesEl.childElementCount) return;
      beginTurn(addBubble("assistant", greeting));
    }

    if (openBtn) {
      openBtn.addEventListener("click", function () {
        ensureGreeting();
        setOpen(true);
      });
    }
    if (closeBtn) closeBtn.addEventListener("click", function () { setOpen(false); });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen) setOpen(false);
    });
    modeButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = btn.getAttribute("data-care-mode");
        if (next === "text") stopTalk();
        setMode(next);
      });
    });
    if (talkBtn) {
      talkBtn.addEventListener("click", function () {
        if (root.classList.contains("is-live") || voice.connecting) stopTalk();
        else startTalk();
      });
    }
    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var text = input && input.value ? input.value.trim() : "";
        if (!text) return;
        input.value = "";
        input.style.height = "auto";
        if (voice.ws && voice.ws.readyState === 1) {
          beginTurn(addBubble("user", text));
          history.push({ role: "user", content: text });
          voice.ws.send(JSON.stringify({
            type: "conversation.item.create",
            item: {
              type: "message",
              role: "user",
              content: [{ type: "input_text", text: text }]
            }
          }));
          voice.ws.send(JSON.stringify({ type: "response.create" }));
          return;
        }
        sendChat(text);
      });
    }
    if (sendBtn) {
      sendBtn.addEventListener("pointerdown", function (event) {
        event.preventDefault();
      });
    }
    if (input) {
      input.addEventListener("input", function () {
        input.style.height = "auto";
        input.style.height = Math.min(input.scrollHeight, 104) + "px";
      });
      input.addEventListener("keydown", function (event) {
        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault();
          form.dispatchEvent(new Event("submit", { cancelable: true }));
        }
      });
    }

    setMode("text");

    var params = new URLSearchParams(window.location.search);
    var careParam = params.get("care");
    if (careParam === "1" || careParam === "talk" || window.location.hash === "#care") {
      ensureGreeting();
      if (careParam === "talk") setMode("talk");
      setOpen(true);
    }
  });
})();
